<template>
<div
  class="wallet-workpackage-rework font-weight-light"
  :style="`
    ${selected
      ?
        `position: fixed;
        padding: 0px 0px 0px 0px;
        border-radius: 10px;
        top: ${$vuetify.breakpoint.smAndDown?'3px':'84px'};
        z-index: 100;
        height: ${$vuetify.breakpoint.smAndDown?`calc(${mobile_height}px - 6px)`:'calc(100vh - 117px)'};
        width: ${!$vuetify.breakpoint.smAndDown?'calc((100vw - 50px) / 3 - 20px)':'calc(100vw - 20px)'};`
      :
        `z-index: 0;
        width: ${!$vuetify.breakpoint.smAndDown?'calc((100vw - 50px) / 3 - 20px)':'calc(100vw - 20px)'};`
    }
    ${index === count - 1 && !selected
      ? 'margin-bottom: -25px;'
      : ''
    }
    ${index !== 0 && !selected && !is_show_status_popup
      ? 'margin-top: -10px;'
      : ''
    }
    ${!selected && is_show_status_popup
      ? (index !== 0
        ? 'margin-top: -70px;'
        : 'margin-top: -60px;')
      : ''
    }
  `
  "
  >
  <div
    :class="`wallet-workpackage-rework-header-slot${selected}`"
    :style="is_show_status_popup && !selected?'margin-bottom: 60px':''"
    >
    <slot
      name="header"
      />
  </div>
  <div
    :class="`wallet-workpackage-rework-body-slot${selected}`"
    :style="selected === '-selected'?($vuetify.breakpoint.smAndDown?`height: calc(${mobile_height}px - 6px - 80px);`:'height: calc(100vh - 114px - 80px);'):''"
    >
    <slot name="body"/>
  </div>
</div>
</template>
<script>
export default {
  props: ['selected', 'other_selected', 'index', 'count', 'is_show_status_popup'],
  data: () => ({

  }),
  computed: {
    mobile_height() {
      return window.innerHeight;
    }
  }
}
</script>
<style>
.wallet-workpackage-rework {
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc((100vw - 50px) / 3 - 20px);
  /* justify-content: center; */
  align-items: center;
  font-size: 16px;
  user-select: none;
  /* z-index: 3; */
  /* margin-top: -3px; */
  top: 0px;
  border-radius: 10px 10px 0px 0px;
  padding-bottom: 10px;
  box-shadow: 0px 0px 3px 0px #000000;
  overflow: hidden;
  transition: margin-top 0.2s ease-in-out;
}
/* .wallet-workpackage-rework-selected {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  user-select: none;
  z-index: 2;

  padding: 10px;
  position: relative;
  top: calc(-100vh + 200px);
  transition: all 0.2s ease-in-out
} */

.wallet-workpackage-rework-body-slot {
  position: relative;
  width: 100%;
}
.wallet-workpackage-rework-body-slot-selected {
  position: relative;
  width: 100%;
}

/* header normal */
.wallet-workpackage-rework-header-slot {
  width: 100%;
  transition: margin-bottom 0.2s ease-in-out;
  z-index: 101;
  cursor: pointer;
  /* margin-bottom: 0px;
  transition: margin 0.2s ease-in-out; */
}
/* .wallet-workpackage-rework-header-slot:hover {
  margin-top: -20px;
  margin-bottom: -16px;
} */

/* header seleceted */
.wallet-workpackage-rework-header-slot-selected {
  width: 100%;
  transition: margin-bottom 0.2s ease-in-out;
  z-index: 101;
  cursor: pointer;
  /* margin-top: -20px;
  margin-bottom: -16px; */
}

/* header other selected */
.wallet-workpackage-rework-header-slot-other-selected {
  /* width: 100%;
  margin-top: -40px;
  margin-bottom: -28px;
  transition: margin 0.2s ease-in-out; */
}
/* .wallet-workpackage-rework-header-slot-other-selected:hover {
  width: 100%;
  margin-top: -20px;
  margin-bottom: -40px;
} */
</style>
